import { Redirect } from 'react-router-dom';
import { routes } from 'Constants/routes';

const GenericRoute = (): JSX.Element => {
  return <Redirect to={routes.DASHBOARD} />;
};

export default GenericRoute;
